import type { TaskResult } from "../types";

function normalizeFormula(value: string | undefined): string {
  return (value ?? "").replace(/\$/g, "").replace(/\s+/g, "").replace(/^=/, "").toUpperCase();
}

export async function gradeProject19(): Promise<TaskResult[]> {
  const results: TaskResult[] = [];

  // Tarea 1: Verificar salto de página antes de la fila 21 en Costos
  try {
    await Excel.run(async (context) => {
      const sheet = context.workbook.worksheets.getItem("Costos");
      const hBreaks = sheet.horizontalPageBreaks;
      hBreaks.load("items");
      await context.sync();

      // Verificar que existe un salto de página en la fila 21
      let passed = false;
      for (const br of hBreaks.items) {
        br.load("rowIndex");
      }
      await context.sync();
      for (const br of hBreaks.items) {
        // rowIndex es 0-based, fila 21 = index 20
        if (br.rowIndex === 20) {
          passed = true;
          break;
        }
      }
      results.push({ taskId: 1, passed });
    });
  } catch (e) {
    console.error("[P19-T1] ERROR:", e);
    results.push({ taskId: 1, passed: false });
  }

  // Tarea 2: Verificar que A2 en Costos tiene formato copiado de Ganancias
  // (fondo marrón, texto blanco, negrita, tamaño 14)
  try {
    await Excel.run(async (context) => {
      const sheet = context.workbook.worksheets.getItem("Costos");
      const cell = sheet.getRange("A2");
      cell.format.fill.load("color");
      cell.format.font.load("bold,color,size");
      await context.sync();

      const fillColor = String(cell.format.fill.color).toUpperCase();
      const isBold = cell.format.font.bold;
      const fontSize = cell.format.font.size;
      // Verificar que tiene formato aplicado (no default)
      const hasFormat = isBold && fontSize >= 14 && fillColor !== "#FFFFFF" && fillColor !== "";
      results.push({ taskId: 2, passed: hasFormat });
    });
  } catch (e) {
    console.error("[P19-T2] ERROR:", e);
    results.push({ taskId: 2, passed: false });
  }

  // Tarea 3: PROMEDIO en A29 de Ganancias
  try {
    await Excel.run(async (context) => {
      const sheet = context.workbook.worksheets.getItem("Ganancias");
      const cell = sheet.getRange("A29");
      cell.load("formulas,values");
      await context.sync();

      const formula = normalizeFormula(String(cell.formulas[0][0] ?? ""));
      const value = Number(cell.values[0][0]);
      // Aceptar AVERAGE/PROMEDIO con referencia de celdas o estructurada
      const hasAvgFn = formula.includes("AVERAGE") || formula.includes("PROMEDIO");
      const hasRef = formula.includes("B4:B26") || formula.includes("[COSTO]");
      results.push({
        taskId: 3,
        passed: hasAvgFn && hasRef && Math.abs(value - 1.73) < 0.1,
      });
    });
  } catch {
    results.push({ taskId: 3, passed: false });
  }

  // Tarea 4: Ganancia Total en el gráfico
  try {
    await Excel.run(async (context) => {
      const sheet = context.workbook.worksheets.getItem("Ganancias");
      const chart = sheet.charts.getItemAt(0);
      const series = chart.series;
      series.load("items/name");
      await context.sync();

      const names = series.items.map((item) => item.name);
      results.push({
        taskId: 4,
        passed: names.some((name) => String(name).toUpperCase().includes("GANANCIA TOTAL")),
      });
    });
  } catch {
    results.push({ taskId: 4, passed: false });
  }

  // Tarea 5: Filtrar costos superiores al promedio
  try {
    await Excel.run(async (context) => {
      const sheet = context.workbook.worksheets.getItem("Ganancias");
      const table = sheet.tables.getItemAt(0);
      const costColumn = table.columns.getItem("Costo");
      const filter = costColumn.filter;
      filter.load("criteria");
      await context.sync();

      // El filtro "Superior del promedio" aplica un DynamicFilterCriteria
      const criteria = filter.criteria;
      const isDynamic = criteria?.filterOn === "Dynamic";
      const isAboveAvg = String(criteria?.dynamicCriteria ?? "").toLowerCase().includes("aboveaverage");
      console.log("[P19-T5] criteria:", JSON.stringify(criteria));
      results.push({ taskId: 5, passed: isDynamic && isAboveAvg });
    });
  } catch (e) {
    console.error("[P19-T5] ERROR:", e);
    results.push({ taskId: 5, passed: false });
  }

  return results;
}
